import { render, staticRenderFns } from "./scroll-pagination.vue?vue&type=template&id=07fd8477&scoped=true&lang=html&"
import script from "./scroll-pagination.vue?vue&type=script&lang=js&"
export * from "./scroll-pagination.vue?vue&type=script&lang=js&"
import style0 from "./scroll-pagination.vue?vue&type=style&index=0&id=07fd8477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd8477",
  null
  
)

export default component.exports